import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { Rule } from 'antd/es/form';
import React, { useMemo } from 'react';
import REGEX from 'src/utils/regex';
import { BaseFormItem } from './BaseFormItem';
import { IBaseFormItemProps } from './form.type';

interface IProps extends React.ComponentProps<typeof Input>, IBaseFormItemProps {
  showSearch?: boolean;
  rule?: IInputValidator;
}

interface IInputValidator {
  noSpecial?: boolean;
  isPhone?: boolean;
  isEmail?: boolean;
  isPassword?: boolean;
  required?: boolean;
  minLength?: number;
  maxLength?: number;
}

export function BaseInput(props: IProps) {
  const rules = useMemo(() => {
    return getRules(props);
  }, [props]);

  const placeholder = useMemo(() => {
    return getPlaceholder(props);
  }, [props]);

  const suffix = useMemo(() => {
    return getSuffix(props);
  }, [props]);

  return (
    <BaseFormItem {...props} rules={rules}>
      {!props.rule?.isPassword ? (
        <Input {...props} allowClear size={props.size || 'large'} placeholder={placeholder} suffix={suffix} />
      ) : (
        <Input.Password {...props} allowClear size={props.size || 'large'} placeholder={placeholder} suffix={suffix} />
      )}
    </BaseFormItem>
  );
}

const getSuffix = (props: IProps) => {
  if (props.showSearch) {
    return <SearchOutlined style={{ color: '#999' }} />;
  }

  return props.suffix;
};

const getPlaceholder = (props: IProps) => {
  if (props.placeholder) {
    return props.placeholder;
  }

  return props.label;
};

const getRules = (props: IProps) => {
  let rules: Rule[] = [];
  if (props.rule) {
    if (props.rule.required) {
      rules.push({
        whitespace: true,
        required: true,
        message: `${props.label || props.placeholder} không được để trống!`,
      });
    }

    if (props.rule.minLength) {
      rules.push({
        min: props.rule.minLength,
        message: `${props.label || props.placeholder} phải có tối thiểu ${props.rule.minLength} ký tự!`,
      });
    }

    if (props.rule.maxLength) {
      rules.push({
        max: props.rule.maxLength,
        message: `${props.label || props.placeholder} phải có tối đa ${props.rule.maxLength} ký tự!`,
      });
    }

    if (props.rule.noSpecial) {
      rules.push({
        validator: (_, value) => {
          if (REGEX.isSpecialCharacter(value) || REGEX.isEmoji(value)) {
            return Promise.reject(new Error(`${props.label || props.placeholder} không được chứa ký tự đặc biệt!`));
          }
          return Promise.resolve();
        },
      });
    }

    if (props.rule.isPhone) {
      rules.push({
        pattern: new RegExp(REGEX.REGEX_PHONE),
        message: `${props.label || props.placeholder} không đúng định dạng!`,
      });
    }

    if (props.rule.isEmail) {
      rules.push({
        pattern: new RegExp(REGEX.REGEX_EMAIL),
        message: `${props.label || props.placeholder} không đúng định dạng!`,
      });
    }

    // if (props.rule.isPassword) {
    //   rules.push({
    //     pattern: new RegExp(REGEX.REGEX_EMAIL),
    //     message: `${props.label} phải chứa tối thiểu tám ký tự, ít nhất một chữ cái viết hoa, một chữ cái viết thường, một số và một ký tự đặc biệt!`,
    //   });
    // }
  }

  if (props.rules) {
    rules = [...rules, ...props.rules];
  }

  return rules.length > 0 ? rules : undefined;
};
